export const ROI = {
  /* profile */
  myCharCheck:   { x: 1211, y: 87, w: 50, h: 28 },
  myCharCheck2:   { x: 1269, y: 87, w: 50, h: 28 },
  job:           { x: 947,  y: 174, w: 184, h: 26 },
  jobEngraving:  { x: 947,  y: 548, w: 187, h: 25 },
  level:         { x: 1736, y: 160, w: 140, h: 50 },
  power:         { x: 1766, y: 254, w: 82,  h: 24 },
  /* header/meta */
  raidName:      { x: 454,  y: 46,  w: 830, h: 32 },
  battleTime:    { x: 614,  y: 136, w: 63,  h: 30 },
  timestamp:     { x: 1624, y: 50,  w: 122, h: 15 },
  /* main traits */
  mainTrait1:      { x: 501,  y: 180, w: 273, h: 32 },
  mainTrait1Value: { x: 501,  y: 231, w: 273, h: 32 },
  mainTrait2:      { x: 861,  y: 180, w: 273, h: 32 },
  mainTrait2Value: { x: 861,  y: 231, w: 273, h: 32 },
  mainTrait3:      { x: 1230, y: 180, w: 273, h: 32 },
  mainTrait3Value: { x: 1230, y: 231, w: 273, h: 32 },
  mainTrait4:      { x: 1590, y: 180, w: 273, h: 32 },
  mainTrait4Value: { x: 1590, y: 231, w: 273, h: 32 },
  /* add traits (순서대로 name → value) */
  addTrait1:       { x: 489,  y: 406, w: 273, h: 32 },
  addTrait1Value:  { x: 868,  y: 406, w: 273, h: 32 },
  addTrait2:       { x: 1202, y: 406, w: 273, h: 32 },
  addTrait2Value:  { x: 1584, y: 406, w: 273, h: 32 },
  addTrait3:       { x: 489,  y: 478, w: 273, h: 32 },
  addTrait3Value:  { x: 868,  y: 478, w: 273, h: 32 },
  addTrait4:       { x: 1202, y: 478, w: 273, h: 32 },
  addTrait4Value:  { x: 1584, y: 478, w: 273, h: 32 },
  addTrait5:       { x: 489,  y: 550, w: 273, h: 32 },
  addTrait5Value:  { x: 868,  y: 550, w: 273, h: 32 },
  addTrait6:       { x: 1202, y: 550, w: 273, h: 32 },
  addTrait6Value:  { x: 1584, y: 550, w: 273, h: 32 },
  addTrait7:       { x: 489,  y: 622, w: 273, h: 32 },
  addTrait7Value:  { x: 868,  y: 622, w: 273, h: 32 },
  addTrait8:       { x: 1202, y: 622, w: 273, h: 32 },
  addTrait8Value:  { x: 1584, y: 622, w: 273, h: 32 },
  addTrait9:       { x: 489,  y: 694, w: 273, h: 32 },
  addTrait9Value:  { x: 868,  y: 694, w: 273, h: 32 },
  addTrait10:      { x: 1202, y: 694, w: 273, h: 32 },
  addTrait10Value: { x: 1584, y: 694, w: 273, h: 32 },
  addTrait11:      { x: 489,  y: 766, w: 273, h: 32 },
  addTrait11Value: { x: 868,  y: 766, w: 273, h: 32 },
  addTrait12:      { x: 1202, y: 766, w: 273, h: 32 },
  addTrait12Value: { x: 1584, y: 766, w: 273, h: 32 },
  addTrait13:      { x: 489,  y: 838, w: 273, h: 32 },
  addTrait13Value: { x: 868,  y: 838, w: 273, h: 32 },
  addTrait14:      { x: 1202, y: 838, w: 273, h: 32 },
  addTrait14Value: { x: 1584, y: 838, w: 273, h: 32 },
};
export const ROI_SECOND_PASS_16 = {
  addTrait15:      { x: 489,  y: 838, w: 273, h: 32 },
  addTrait15Value: { x: 868,  y: 838, w: 273, h: 32 },
  addTrait16:      { x: 1202, y: 838, w: 273, h: 32 },
  addTrait16Value: { x: 1584, y: 838, w: 273, h: 32 },
};
export const ROI_SECOND_PASS_18 = {
  addTrait15:      { x: 489,  y: 766, w: 273, h: 32 },
  addTrait15Value: { x: 868,  y: 766, w: 273, h: 32 },
  addTrait16:      { x: 1202, y: 766, w: 273, h: 32 },
  addTrait16Value: { x: 1584, y: 766, w: 273, h: 32 },
  addTrait17:      { x: 489,  y: 838, w: 273, h: 32 },
  addTrait17Value: { x: 868,  y: 838, w: 273, h: 32 },
  addTrait18:      { x: 1202, y: 838, w: 273, h: 32 },
  addTrait18Value: { x: 1584, y: 838, w: 273, h: 32 },
};
